<script lang="ts">
	import Icon from "../Icon.svelte";
	import chevronDown from "../../../../core/assets/icons/arrow-down.svg?raw";
	import type { FilterOption } from "../../../../core/schema/FilterOption";

	export let value: unknown = undefined;
	export let options: FilterOption[] = [];
	export let disabled = false;
	export let required = false;
	export let id: string | undefined = undefined;
	let selectClass = "";
	export { selectClass as class };
	export let iconClass = "";
	export let inputClass = "";
</script>

<div
	class="placeholder-shown:bg-secondary-50 placeholder-shown:shadow-input relative flex h-[3.5rem] w-full cursor-text overflow-hidden rounded-[0.25rem] border-[0.0625rem] border-secondary-250 bg-white text-base leading-8 text-black placeholder-shown:border-secondary-250 focus:bg-white focus:outline-none lg:w-auto {selectClass}"
>
	<Icon
		icon={chevronDown}
		class="pointer-events-none absolute bottom-0 right-2 top-0 my-auto h-5 lg:right-5 {iconClass}"
	/>
	<select
		class="w-full appearance-none bg-white py-2 pl-3 pr-6 text-xs outline-0 lg:pl-6 lg:pr-12 lg:text-base {inputClass}"
		{required}
		{disabled}
		{id}
		name={id}
		bind:value
		on:change
	>
		{#each options as option}
			<option value={option.value} selected={option.selected}>{option.label}</option>
		{/each}
	</select>
</div>
